import { useContext } from 'react'

import {
  MeetingsMeetingContext,
  MeetingsMeetingContextState,
} from 'modules/meetings/lib/context/MeetingsMeetingContext'

export const useMeeting = (): MeetingsMeetingContextState => {
  const context = useContext(MeetingsMeetingContext)

  if (context === undefined) {
    throw new Error('useMeetingsMeeting must be used within a MeetingsMeetingProvider')
  }

  return context
}
